export default {"src":"/_next/static/media/minidiftman-delivery.55becd75.svg","height":73,"width":73,"blurWidth":0,"blurHeight":0};